import React from "react";
import styled from "@emotion/styled";
import { mediaQueriesMax } from "@src/styles/theme";
import { Box } from "@src/components/Boxes";
import IdeasFollow from "@src/components/ideas/IdeasFollow";

const Publisher = styled("div")`
  position: relative;
  color: #575b7d;

  margin: 20px 0 0 0;

  ${mediaQueriesMax[0]} {
    padding-left: 20px;
  }

  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9e9e5;
  border-radius: 5px;
  padding: 32px;
  padding-left: 41px;
`;

const PublisherAvatar = styled("div")`
  display: inline-block;
  width: 48px;
  margin-right: 12px;

  img {
    display: block;
    width: 100%;
  }

  vertical-align: middle;
`;

const PublisherData = styled("div")`
  display: inline-block;

  > div {
    line-height: 1;
  }

  vertical-align: middle;
`;

const Action = styled("div")`
  position: absolute;
  top: 50%;
  margin-top: -1.08em;
  right: 20px;
`;

const Title = styled("div")`
  font-size: 18px;
  font-weight: 600;
`;

const LessonPublisher = (props) => {
  const { visible } = props;

  if (!(visible === undefined) && !visible) {
    return null;
  }

  return (
    <Publisher>
      <PublisherAvatar>
        <img src={props.publisher.photo.localFile.publicURL || "http://placehold.it/72x72"} />
      </PublisherAvatar>
      <PublisherData>
        <Title>{props.publisher.name}</Title>
        {props.publisher.idea_count && (
          <Box marginTop="8px">
            {props.publisher.idea_count} {props.publisher.idea_type}
          </Box>
        )}
        <Action>
          <IdeasFollow {...props} bigButton />
        </Action>
      </PublisherData>
    </Publisher>
  );
};

export default LessonPublisher;
